import React, { useEffect, useRef, useState } from 'react';

const CustomCursor: React.FC = () => {
  const followerRef = useRef<HTMLDivElement>(null);
  const cursorRef = useRef<HTMLDivElement>(null);
  const [isHovering, setIsHovering] = useState(false);
  const [isClicking, setIsClicking] = useState(false);

  useEffect(() => {
    document.body.style.cursor = 'none';

    const onMouseMove = (e: MouseEvent) => {
      if (cursorRef.current) {
        cursorRef.current.style.left = `${e.clientX}px`;
        cursorRef.current.style.top = `${e.clientY}px`;
      }
      
      if (followerRef.current) {
        followerRef.current.style.left = `${e.clientX}px`;
        followerRef.current.style.top = `${e.clientY}px`;
      }
    };

    const onMouseDown = () => setIsClicking(true);
    const onMouseUp = () => setIsClicking(false);
    
    const onMouseEnter = () => setIsHovering(true);
    const onMouseLeave = () => setIsHovering(false);

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mouseup', onMouseUp);
    
    const interactiveElements = Array.from(
      document.querySelectorAll('a, button, input, textarea, select, [role="button"]')
    );
    
    interactiveElements.forEach(el => {
      el.addEventListener('mouseenter', onMouseEnter);
      el.addEventListener('mouseleave', onMouseLeave);
    });

    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mousedown', onMouseDown);
      window.removeEventListener('mouseup', onMouseUp);
      
      interactiveElements.forEach(el => {
        el.removeEventListener('mouseenter', onMouseEnter);
        el.removeEventListener('mouseleave', onMouseLeave);
      });
      
      document.body.style.cursor = 'auto';
    };
  }, []);

  useEffect(() => {
    if (!followerRef.current) return;

    if (isClicking) {
      followerRef.current.style.width = '8px';
      followerRef.current.style.height = '8px';
      followerRef.current.style.backgroundColor = '#2e79b9';
      followerRef.current.style.borderWidth = '0';
    } else if (isHovering) {
      followerRef.current.style.width = '25px';
      followerRef.current.style.height = '25px';
      followerRef.current.style.backgroundColor = 'transparent';
      followerRef.current.style.borderWidth = '1px';
    } else {
      followerRef.current.style.width = '18px';
      followerRef.current.style.height = '18px';
      followerRef.current.style.backgroundColor = 'transparent';
      followerRef.current.style.borderWidth = '1px';
    }
  }, [isHovering, isClicking]);

  return (
    <>
      <div
        ref={followerRef}
        className="fixed pointer-events-none z-[9998] rounded-full border border-[#4f837d] transition-all duration-100 ease-linear"
        style={{
          left: '0px',
          top: '0px',
          transform: 'translate(-50%, -50%)',
          width: '18px',
          height: '18px',
        }}
      />

      <div
        ref={cursorRef}
        className="fixed w-1 h-1 pointer-events-none z-[9999] rounded-full bg-[#155679]"
        style={{
          left: '0px',
          top: '0px',
          transform: 'translate(-50%, -50%)',
        }}
      />
    </>
  );
};

export default CustomCursor;